import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "../styles/Home.css";

export default function Contact() {

  const form = useRef();
  const [sent, setSent] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      "service_k400dag",
      "template_eju5mq9",
      form.current,
      "1JbtPn9y7Tbw9-SQS"
    )
    .then(() => {
      setSent(true);
      e.target.reset();
    })
    .catch(() => {
      alert("Failed to send message.");
    });
  };

  return (
    <>

      {/* Page Header */}

      <section className="section">
        <div className="container" style={{ textAlign: "center" }}>
          <h1 style={{ fontSize: "40px", marginBottom: "10px" }}>
            Contact Us
          </h1>

          <p style={{ color: "#555" }}>
            Let's build something powerful together.
          </p>
        </div>
      </section>


      {/* Contact Info */}

      <section className="section">
        <div className="container">

          <div className="services">

            <div className="service-card">
              <h3>📧 Email</h3>
              <p>softwarealmond@gmail.com</p>
            </div>

            <div className="service-card">
              <h3>📸 Instagram</h3>
              <p>@almondsoftware</p>
            </div>

<div className="service-card">
  <h3>💬 Telegram</h3>

  <p>
    <a 
      href="https://t.me/almondsoft"
      target="_blank"
      rel="noreferrer"
      style={{textDecoration:"none", color:"#4f46e5", fontWeight:"500"}}
    >
     DM on telegram
    </a>
  </p>

</div>

            <div className="service-card">
              <h3>📍 Location</h3>
              <p>Raipur, India (CG)</p>
            </div>

          </div>

        </div>
      </section>


      {/* Contact Form */}

      <section className="section">
        <div className="container" style={{ maxWidth: "600px" }}>

          {!sent ? (

            <form ref={form} onSubmit={sendEmail} className="contact-form">

              <input
                type="text"
                name="name"
                placeholder="Name"
                required
              />

              <input
                type="email"
                name="email"
                placeholder="Email"
                required
              />

              <textarea
                name="message"
                placeholder="Message"
                rows="5"
                required
              ></textarea>

              <button className="btn-primary" type="submit">
                Send Message
              </button>

            </form>

          ) : (

            <div className="email-success">

              <div className="checkmark">✓</div>

              <h2>Message Sent!</h2>

              <p>
                Thanks for contacting AlmondSoftware.
                We will get back to you soon.
              </p>

            </div>

          )}

        </div>
      </section>


      {/* Footer */}

      <footer className="footer">
        <div className="container">

          <p>© 2024 AlmondSoftware. All rights reserved.</p>

          <p style={{ marginTop: "10px" }}>
            Engineering digital products with intelligence
          </p>

        </div>
      </footer>

    </>
  );
}